import React from 'react';
import loadable from '@loadable/component';

const PriceFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "PriceFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/PriceFilter/component'
    ),
);

class LoadablePriceFilter extends React.Component {
  render() {
    return <PriceFilter {...this.props} />;
  }
}

export default LoadablePriceFilter;
